import LoadingButton from "@mui/lab/LoadingButton";
import {
  Alert,
  AlertTitle,
  TextField,
  Typography,
  Container,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Field, Form } from "react-final-form";
import { useParams } from "react-router-dom";
import { useApi } from "../utils/api";
import Loading from "./Layout/Loading";
import { InlineWidget } from "react-calendly";

const ClientIntakeForm = () => {
  const { submitClientIntake, getUser } = useApi();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [coach, setCoach] = useState(null);
  const [client, setClient] = useState(null);
  const { encodedCoachId } = useParams();
  const coachId = atob(encodedCoachId);

  useEffect(() => {
    getUser(coachId).then((user) => {
      setCoach(user);
    });
  }, [coachId]);

  const required = (v) => {
    return !v ? "This field is required" : undefined;
  };
  const onSubmit = async (v) => {
    setLoading(true);
    await submitClientIntake({ ...v, coachId });
    setClient({ ...v, coachId });
    setLoading(false);
    setSuccess(true);
  };

  if (!coach) {
    return (
      <Container sx={{ mt: 2 }}>
        <Loading />
      </Container>
    );
  }

  if (success) {
    return (
      <Container sx={{ mt: 2 }}>
        <InlineWidget
          url="https://calendly.com/mike-trainer-app/30min"
          styles={{ minWidth: "320px", height: "800px" }}
          pageSettings={{
            hideLandingPageDetails: true,
            primaryColor: "#ff0012",
          }}
          prefill={{
            name: client.fullname,
            email: client.email,
          }}
        />
      </Container>
    );
  }
  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <>
            <Typography variant="h6">
              {coach.name}'s Client Intake Form
            </Typography>
            <form
              onSubmit={handleSubmit}
              sx={{ display: "flex", flexDirection: "column", gap: 4 }}
            >
              <Field
                name="dateSubmitted"
                render={({ input }) => (
                  <input type="hidden" value={input.value} />
                )}
              />
              <Field
                name="fullname"
                validate={required}
                render={({ input, meta }) => (
                  <TextField
                    label="Full Name"
                    {...input}
                    error={meta.touched && meta.error}
                    helperText={meta.touched && meta.error}
                    sx={{ mt: 2 }}
                    size="small"
                    fullWidth
                  />
                )}
              />
              <Field
                name="email"
                validate={required}
                render={({ input, meta }) => (
                  <TextField
                    label="Email"
                    type="email"
                    {...input}
                    error={meta.touched && meta.error}
                    helperText={meta.touched && meta.error}
                    sx={{ mt: 2 }}
                    size="small"
                    fullWidth
                  />
                )}
              />
              <Field
                name="age"
                validate={required}
                render={({ input, meta }) => (
                  <TextField
                    label="Age"
                    {...input}
                    error={meta.touched && meta.error}
                    helperText={meta.touched && meta.error}
                    sx={{ mt: 2 }}
                    size="small"
                    fullWidth
                  />
                )}
              />
              <Typography sx={{ mt: 2 }} fontSize="small">
                What are some of your goals?
              </Typography>
              <Field
                name="goals"
                validate={required}
                render={({ input, meta }) => (
                  <TextField
                    label="Goals"
                    {...input}
                    error={meta.touched && meta.error}
                    helperText={meta.touched && meta.error}
                    sx={{ mt: 2 }}
                    size="small"
                    fullWidth
                    multiline
                    rows={2}
                  />
                )}
              />
              <Typography sx={{ mt: 2 }} fontSize="small">
                What does your current exercise routine look like?
              </Typography>
              <Field
                name="currentExercise"
                validate={required}
                render={({ input, meta }) => (
                  <TextField
                    label="Current Exercise"
                    {...input}
                    error={meta.touched && meta.error}
                    helperText={meta.touched && meta.error}
                    sx={{ mt: 2 }}
                    size="small"
                    fullWidth
                    multiline
                    rows={2}
                  />
                )}
              />
              <Typography sx={{ mt: 2 }} fontSize="small">
                Do you have any injuries, current or past, that could affect you
                during exercise?
              </Typography>
              <Field
                name="injuries"
                validate={required}
                render={({ input, meta }) => (
                  <TextField
                    label="Injury history"
                    {...input}
                    error={meta.touched && meta.error}
                    helperText={meta.touched && meta.error}
                    sx={{ mt: 2 }}
                    size="small"
                    fullWidth
                    multiline
                    rows={2}
                  />
                )}
              />
              <Typography sx={{ mt: 2 }} fontSize="small">
                Do you have any medical conditions that could affect you during
                exercise? (Asthma, Diabetes, High Blood Pressure, etc).
              </Typography>
              <Field
                name="medical"
                validate={required}
                render={({ input, meta }) => (
                  <TextField
                    label="Medical History"
                    {...input}
                    error={meta.touched && meta.error}
                    helperText={meta.touched && meta.error}
                    sx={{ mt: 2 }}
                    size="small"
                    fullWidth
                    multiline
                    rows={2}
                  />
                )}
              />
              <Typography sx={{ mt: 2 }} fontSize="small">
                Anything else I should know?
              </Typography>
              <Field
                name="extra"
                render={({ input }) => (
                  <TextField
                    label="Anything else?"
                    {...input}
                    sx={{ mt: 2 }}
                    size="small"
                    fullWidth
                    multiline
                    rows={2}
                  />
                )}
              />
              <LoadingButton
                variant="contained"
                fullWidth
                sx={{ mt: 4 }}
                type="submit"
                loading={loading}
              >
                Submit
              </LoadingButton>
            </form>
          </>
        )}
      />
    </Container>
  );
};

export default ClientIntakeForm;
